module.exports = __webpack_public_path__ + "img/reserve_905017_r3@2x.0bf0df97.png";